<template>
  <b-modal
    v-model="open"
    title="Complete Documents"
    header-class="header"
    header-text-variant="light"
    @close="close"
    no-close-on-esc
    no-close-on-backdrop
  >
    <div>
      <b-row class="mb-1">
        <b-col>
          <div class="content-title">
            Select documents to complete:
          </div>
        </b-col>
      </b-row>

      <document-picker
        :docs="
          documents &&
            documentsToPicker.filter(doc => doc.data.status === 'Pending')
        "
        v-model="documentsToCompleteAndLockComputed"
        :hideStatusBadge="true"
        :hideDateCreated="true"
        :hideLoadMore="true"
      />

      <span class="text-danger"
        ><small
          ><i class="fas fa-info-circle mr-1"></i>Only documents in PENDING
          status can be completed from this section</small
        >
      </span>
    </div>
    <template #modal-footer class="footer">
      <div class="w-100">
        <b-button
          variant="success"
          class="float-right ml-2"
          @click="completeLock"
          :disabled="documentsToCompleteAndLock.length === 0"
        >
          Next
        </b-button>
        <b-button variant="light" class="float-right bg-gray" @click="close">
          Close
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import DocumentPicker from "../controls/DocumentPicker.vue";
export default {
  name: "CompleteDocumentsBulkModal",
  components: { DocumentPicker },
  props: ["open", "documents"],
  emits: ["close", "completeLock"],
  data() {
    return {
      documentsToCompleteAndLock: []
    };
  },
  methods: {
    close(event) {
      event.preventDefault();
      this.$emit("close");
    },
    completeLock() {
      this.setDocuments();
      this.$emit("completeLock", this.documentsToCompleteAndLock);
      this.documentsToCompleteAndLock = [];
    },
    setDocuments() {
      let data = [];
      this.documents.forEach(document => {
        this.documentsToCompleteAndLock.forEach(doc => {
          if (doc === document.documentId) {
            data.push(document);
          }
        });
      });
      this.documentsToCompleteAndLock = data;
    }
  },
  computed: {
    documentsToPicker() {
      return this.documents.map(document => {
        return {
          data: document
        };
      });
    },
    documentsToCompleteAndLockComputed: {
      get() {
        return this.documentsToCompleteAndLock.map(d => ({
          documentId: d,
          readonly: true
        }));
      },
      set(newValue) {
        this.documentsToCompleteAndLock = newValue.map(d => d.documentId);
      }
    }
  }
};
</script>

<style lang="scss">
.header {
  background-color: var(--purple);

  .modal-title {
    font-size: 20px;
    font-weight: bold;
    line-height: 1.5;
  }
}

.content-title {
  font-weight: bold;
  font-size: 14px;
}
</style>
